import React from 'react';

import { Accordion, Avatar, Box, Text } from '@ublend-npm/aulaui-core';

import { EDUCATOR_ROLE } from '@core/constants/space';

import ParticipantHistoryAccordionItem from './ParticipantHistoryAccordionItem';
import { ParticipantHistoryEvent } from './types';

type ParticipantHistoryAccordionProps = {
  event: ParticipantHistoryEvent;
};

const ParticipantHistoryAccordion = ({
  event,
}: ParticipantHistoryAccordionProps) => {
  return (
    <Accordion
      key={event.eventType}
      arrowPosition="right"
      headerElement={
        <Box sx={{ py: 1, display: 'flex', gap: 1.5, alignItems: 'center' }}>
          <Avatar
            fallbackText={event.data.length.toString()}
            sx={{ width: 32, height: 32 }}
          />
          <Text>
            {event.data.length} users were {event.eventType} by {event.user}
          </Text>
        </Box>
      }
      sx={{
        mt: 1,
        background: 'transparent',
        '& .MuiAccordionSummary-root': {
          '&:hover': { background: 'transparent' },
        },
        '& .MuiAccordionSummary-content': { ml: '0 !important' },
        '& .MuiAccordionDetails-root': { p: 0, '& > .MuiBox-root': { p: 0 } },
      }}
    >
      {event.data.map((ev) => (
        <ParticipantHistoryAccordionItem
          avatar={ev.participant.avatar}
          isEducator={ev.role === EDUCATOR_ROLE}
          firstName={ev.participant.firstName}
          lastName={ev.participant.lastName}
        />
      ))}
    </Accordion>
  );
};

export default ParticipantHistoryAccordion;
